import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import QuotationBuilder from "@/pages/QuotationBuilder";
import QuotationPreview from "@/pages/QuotationPreview";
import DrawingLibrary from "@/pages/DrawingLibrary";
import RateLibrary from "@/pages/RateLibrary";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quotation/new"
              element={
                <ProtectedRoute>
                  <QuotationBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quotation/:id/edit"
              element={
                <ProtectedRoute>
                  <QuotationBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quotation/:id/preview"
              element={
                <ProtectedRoute>
                  <QuotationPreview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/library"
              element={
                <ProtectedRoute>
                  <DrawingLibrary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rates"
              element={
                <ProtectedRoute>
                  <RateLibrary />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
